<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-menu-button data-test="menuButton" auto-hide="false"></ion-menu-button>
        </ion-buttons>
            <ion-title data-test="title">Dashboard</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <h1>ShuttleNomix Backend</h1>
    <h4>Place overall and today's stats here.</h4>
<!-- 
    <ion-button (click)="onOpenSidemenuClick()">Open Sidemenu</ion-button>
    <ion-button (click)="onCloseSidemenuClick()">Close Sidemenu</ion-button> -->
</ion-content>